/**
 * 고객 리뷰 (평가) 서비스
 * 담당자 확정안 (2026-04-23):
 *   - 완료 서비스에 대해 고객이 별점(1~5) + 태그 + 한줄 코멘트 남김
 *   - rating 0~3점 저장 시 Cloud Function(onReviewCreated)으로 complaint_logs 자동 적재 (저평점 불만)
 */
import { db } from '../firebase/config';
import {
  collection, addDoc, getDocs, query, where, serverTimestamp, limit,
} from 'firebase/firestore';

const COL = 'reviews';

/** 만족도 태그 — 담당자가 확정한 6종 */
export const REVIEW_TAGS = [
  { key: 'kind', label: '친절해요' },
  { key: 'fast', label: '신속해요' },
  { key: 'clean', label: '깔끔해요' },
  { key: 'professional', label: '전문적이에요' },
  { key: 'fair_price', label: '가격 합리적' },
  { key: 'recommend', label: '추천하고 싶어요' },
];

export const REVIEW_COMMENT_MAX = 200;

/**
 * 리뷰 작성
 * @param {object} data {serviceRequestId, customerId, partnerId, category, rating, tags, comment}
 * @returns {string} 생성된 문서 ID
 */
export const createReview = async (data) => {
  const ref = await addDoc(collection(db, COL), {
    serviceRequestId: data.serviceRequestId || null,
    customerId: data.customerId || null,
    customerName: data.customerName || '',
    partnerId: data.partnerId || null,
    partnerName: data.partnerName || '',
    sourceRealtorId: data.sourceRealtorId || null,
    category: data.category || '',
    rating: Number(data.rating) || 0,
    tags: Array.isArray(data.tags) ? data.tags : [],
    comment: (data.comment || '').slice(0, REVIEW_COMMENT_MAX),
    createdAt: serverTimestamp(),
  });
  return ref.id;
};

/**
 * 특정 서비스 요청에 리뷰가 이미 작성됐는지 확인
 */
export const hasReviewForRequest = async (serviceRequestId) => {
  if (!serviceRequestId) return false;
  try {
    const q = query(
      collection(db, COL),
      where('serviceRequestId', '==', serviceRequestId),
      limit(1)
    );
    const snap = await getDocs(q);
    return !snap.empty;
  } catch {
    return false;
  }
};
